export const GLOBAL_RATING_OPTIONS = [
  "number",
  "name",
  "IndicatorQuarter1",
  "IndicatorQuarter2",
  "IndicatorQuarter1_2",
  "IndicatorQuarter3",
  "IndicatorQuarter2_3",
  "IndicatorQuarter4",
  "IndicatorQuarter3_4",
  "IndicatorYearValue",
  "IndicatorYearPercent",
];

export const NO_ACTUAL_OPTIONS = ["name", "number"];
export const SELECT_GR = ["section_only", "show_all_data"];

export const GLOBAL_RATING_TYPE = {
  indicator: "indicator", //индикатор
  total: "total", //итог
  title: "title", // заголовок
};
